import { dateFormat } from '@app/constants'
import { getFormattedDate } from '@app/utils/date'

import type { TableData } from '@app/types/table'
import type { ResponseDto } from '@app/api/dtos'
import type { GetListsParams } from '@app/api/routes/monitoringLists/types'
import type { DecodedValueMap } from 'use-query-params'
import type { MonitoringListDto } from '@app/api/routes/monitoringLists/dtos'
import type { QueryParamConfigMap } from 'serialize-query-params'
import type { RegistryCurrentListsDataSource } from '../types'

export const adaptGetListsParams = (queryParams: DecodedValueMap<QueryParamConfigMap>): GetListsParams => {
  return {
    monitoringTypeIds: queryParams.monitoringTypeIds,
    storeIds: queryParams.storeIds,
    clusterIds: queryParams.clusterIds,
    clustersGroupIds: queryParams.clustersGroupIds,
    salesOrganizationIds: queryParams.salesOrganizationIds
  }
}

export const adaptRegistryCurrentListsTableData = (
  monitoringListResponse: ResponseDto<MonitoringListDto>
): TableData<RegistryCurrentListsDataSource> => {
  const { count, results: monitoringLists } = monitoringListResponse

  const dataSource: RegistryCurrentListsDataSource[] = monitoringLists.map(dto => ({
    key: dto.id,
    monitoringKind: dto.monitoringType?.monitoringKind.name ?? null,
    monitoringType: dto.monitoringType?.name ?? null,
    promotionName: dto.promo?.promotionNumber ?? null,
    promoDateFrom: getFormattedDate(dto.promo?.dateFrom, dateFormat.DD_MM_YYYY),
    promoDateTo: getFormattedDate(dto.promo?.dateTo, dateFormat.DD_MM_YYYY),
    store: dto.store?.name ?? null,
    cluster: dto.cluster?.name ?? null,
    clustersGroup: dto.clustersGroup?.name ?? null,
    salesOrganization: dto.salesOrganization?.name ?? null,
    productCode: dto.productCodes?.join(', ') ?? null,
    approvalAt: getFormattedDate(dto.approvalAt, dateFormat.DD_MM_YYYY),
    status: dto.status,
    comment: dto.comment
  }))

  return { count, dataSource }
}
